/**
 * Constants for player states used throughout the application
 */

// Player states for different game phases
export const PLAYER_STATES = {
  INSTRUCTIONS: {
    READING: "READING",
    READY: "READY"
  },
  INTER_ROUND: {
    WAITING: "WAITING",
    READY: "READY"
  }
};

// Phase names
export const PLAYER_PHASES = {
  INSTRUCTIONS: "INSTRUCTIONS",
  INTER_ROUND: "INTER_ROUND"
};

// Helper to build a round-specific inter-round phase key
export const getInterRoundPhase = (round) => `INTER_ROUND_${round}`;